import styled from 'styled-components'

export const StyledStartButton = styled.button`
    border:none;
    border-radius:20px;
    margin: 0 0 20px 0;
    padding: 20px;
    min-height:30px;
    width:100%;
    color:#FFF;
    background-color:#222;
    font-size:1rem;
    outline:none;
    cursor:pointer;
    font-family:Pixel;
`;

